import { render, staticRenderFns } from "./StarRow.vue?vue&type=template&id=944f3cae&scoped=true&"
import script from "./StarRow.vue?vue&type=script&lang=js&"
export * from "./StarRow.vue?vue&type=script&lang=js&"
import style0 from "./StarRow.vue?vue&type=style&index=0&id=944f3cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f3cae",
  null
  
)

export default component.exports